module.exports = __webpack_public_path__ + "static/img/268_TO8_2361.0d0fa31.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/268_TO8_2361.jpg
// module id = tWQB
// module chunks = 0